const enableConsole = false;
const enableIphone = false;

window.iphonelog = function(msg) {
  if(!enableConsole && !enableIphone) return;

  if(enableConsole) console.log(msg);

  if(!enableIphone) return;
  const boxId = '__iphone_log_box__';
  let box = document.getElementById(boxId);
  if (!box) {
    box = document.createElement('div');
    box.id = boxId;
    box.style.cssText = 'position:fixed;right:8px;bottom:8px;max-width:90vw;max-height:60vh;overflow:auto;z-index:999999;font:12px/1.4 system-ui; background:#111;color:#fff; padding:8px;border-radius:8px;';
    document.body.appendChild(box);
  }
  const line = document.createElement('div');
  line.style.cssText = 'border-top:1px solid #333;padding-top:4px;margin-top:4px;white-space:pre-wrap;word-break:break-word;';
  line.textContent = `${msg}`;
  box.prepend(line);
}

window.formatError = function(err){
  if (!err) return 'Unknown error';
  if (err instanceof Error) {
    return `${err.name}: ${err.message}\n${err.stack || ''}`;
  }
  try { return typeof err === 'object' ? JSON.stringify(err) : String(err); }
  catch { return String(err); }
}

window.addEventListener('error', (ev) => {
  iphonelog(`window.error: ${ev.message || '(no message)'} @ ${ev.filename || ''}:${ev.lineno || ''}:${ev.colno || ''}`);
}, true);

window.addEventListener('unhandledrejection', (ev) => {
  iphonelog(`unhandledrejection: ${formatError(ev.reason)}`);
});

async function themeComponent(url, isAsync = true, checkDom = false) {
  if (!url || url.trim() === '') {
    iphonelog('themeComponent: URL is empty or undefined', url);
    return;
  }

  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('res-', '').replace('.js', '');
  const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  window.themeloading = window.themeloading || {};

  if (window[className] || window.themeloading[className]) {
    return;
  }

  if (checkDom && document.querySelector(tagName) == null) {
    return;
  }
  iphonelog(`ℹ️ ${tagName}: Carico componente`);

  window.themeloading[className] = true;

  if (isAsync) {
    import(url).then(() => {
      iphonelog(`✅ ${tagName}: import completato (async)`);
    }).catch(err => {
      iphonelog(`❌ ${tagName}: import FALLITO (async): ${formatError(err)}`);
    }).finally(() => {
      window.themeloading[className] = false;
    });
  } else {
    try {
      await import(url);
      iphonelog(`✅ ${tagName}: import tentato (await)`);
    } catch (err) {
      iphonelog(`❌ ${tagName}: import FALLITO (await): ${formatError(err)}`);
    }
    window.themeloading[className] = false;
  }
}
window.themeComponent = themeComponent;


// attivo i popover di bootstrap
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

// Gestione conferma wishlist
window.wishlistConfirm = function(type, callback) {
  const modal = document.getElementById('wishlistConfirmModal');
  if (!modal) {
    // Se il modal non esiste, esegui direttamente l'azione
    callback();
    return;
  }
  
  const modalInstance = new bootstrap.Modal(modal);
  const titleEl = modal.querySelector('#wishlistConfirmModalLabel');
  const messageEl = modal.querySelector('#wishlistConfirmMessage');
  const confirmBtn = modal.querySelector('#wishlistConfirmAction');
  const cancelBtn = modal.querySelector('#wishlistConfirmCancel');
  
  // Imposta i testi in base al tipo
  if (type === 'clear') {
    titleEl.textContent = modal.dataset.clearTitle;
    messageEl.textContent = modal.dataset.clearMessage;
    confirmBtn.textContent = modal.dataset.clearConfirm;
  } else {
    titleEl.textContent = modal.dataset.removeTitle;
    messageEl.textContent = modal.dataset.removeMessage;
    confirmBtn.textContent = modal.dataset.removeConfirm;
  }
  cancelBtn.textContent = modal.dataset.cancel;
  
  // Rimuovi listener precedenti
  const newConfirmBtn = confirmBtn.cloneNode(true);
  confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
  
  // Aggiungi nuovo listener
  newConfirmBtn.addEventListener('click', function() {
    modalInstance.hide();
    callback();
  });
  
  modalInstance.show();
};

window.updateWishlistUI = function(variantId) {
  const wishlistBtn = document.querySelector(`teddy-wishlist-btn[data-variant="${variantId}"]`);
  const wishlistCard = wishlistBtn?.closest('.col');
  const isUnavailable = wishlistBtn?.closest('.wishlist-card')?.querySelector('.overlay.disabled-card') !== null;
  
  // Verifica se siamo nella pagina wishlist o nella collezione
  const isInWishlistPage = document.querySelector('#wishlist-page') !== null;
  const isInCollectionPage = document.querySelector('collection-grid, algolia-collection') !== null;
  
  // Salva i variant ID rimossi nel sessionStorage per persistere dopo il reload
  let removedVariants = JSON.parse(sessionStorage.getItem('removed_wishlist_variants') || '[]');
  if (!removedVariants.includes(variantId)) {
    removedVariants.push(variantId);
    sessionStorage.setItem('removed_wishlist_variants', JSON.stringify(removedVariants));
  }
  
  if (wishlistCard) {
    /*
    wishlistCard.style.transition = 'opacity 0.3s ease-out';
    wishlistCard.style.opacity = '0';
    */
    
    setTimeout(() => {
      /*
      wishlistCard.remove();
      */
      
      const countElement = document.querySelector('[data-wishlist-counter], .fw-bold.small');
      if (countElement) {
        const currentText = countElement.textContent.trim();
        
        const totalMatch = currentText.match(/^(\d+)/);
        if (totalMatch) {
          const currentTotal = parseInt(totalMatch[1]);
          const newTotal = currentTotal - 1;
          
          const unavailableMatch = currentText.match(/\((\d+) non disponibil/);
          let newUnavailable = unavailableMatch ? parseInt(unavailableMatch[1]) : 0;
          
          if (isUnavailable && newUnavailable > 0) {
            newUnavailable--;
          }
          
          if (newTotal === 0) {
            const wishlistContainer = document.querySelector('#wishlist-page .row.row-cols-2, #wishlist-page .row.row-cols-md-4');
            if (wishlistContainer) {
              const emptyMessage = document.querySelector('[data-empty-wishlist-message]')?.textContent || 
                                  'La tua wishlist è vuota';
              wishlistContainer.innerHTML = `
                <div class="col-12 text-center py-5">
                  <p class="mb-0">${emptyMessage}</p>
                </div>
              `;
            }
            
            const clearSection = document.querySelector('teddy-wishlist-clear')?.closest('.border-top');
            if (clearSection) {
              clearSection.remove();
            }
            
            const isItalian = currentText.includes('articol');
            countElement.textContent = isItalian ? '0 articoli presenti' : '0 items';
            
          } else {
            const isItalian = currentText.includes('articol');
            
            let newText;
            if (isItalian) {
              newText = `${newTotal} ${newTotal === 1 ? 'articolo presente' : 'articoli presenti'}`;
            } else {
              newText = `${newTotal} ${newTotal === 1 ? 'item' : 'items'}`;
            }
            
            if (newUnavailable > 0) {
              if (isItalian) {
                const unavailableText = newUnavailable === 1 ? 'non disponibile' : 'non disponibili';
                newText += ` (${newUnavailable} ${unavailableText})`;
              } else {
                newText += ` (${newUnavailable} unavailable)`;
              }
            }
            
            countElement.textContent = newText;
          }
        }
      }
      
      const headerCounter = document.querySelector('[data-wishlist-count], .wishlist-counter, .wishlist-count');
      if (headerCounter) {
        const currentValue = parseInt(headerCounter.textContent) || 0;
        if (currentValue > 0) {
          const newValue = Math.max(0, currentValue - 1);
          headerCounter.textContent = newValue;
          
          if (headerCounter.classList.contains('badge') && newValue === 0) {
            headerCounter.style.display = 'none';
          }
        }
      }
      
      window.dispatchEvent(new CustomEvent('wishlist:updated', { 
        detail: { 
          action: 'removed',
          variantId: variantId,
          remaining: document.querySelectorAll('teddy-wishlist-btn[data-variant]').length - 1
        }
      }));
      
      // Trigger anche l'evento MCEVENTS per aggiornare la wishlist page
      if (window.MCEVENTS && window.MCEVENTS.WISHLIST_CHANGED) {
        window.dispatchEvent(new CustomEvent(window.MCEVENTS.WISHLIST_CHANGED));
      }
    }, 300);
  } else if (isInCollectionPage && !isInWishlistPage) {
    // Se siamo nella pagina collezione, aggiorna solo il contatore nell'header
    const headerCounter = document.querySelector('[data-wishlist-count], .wishlist-counter, .wishlist-count');
    if (headerCounter) {
      const currentValue = parseInt(headerCounter.textContent) || 0;
      if (currentValue > 0) {
        const newValue = Math.max(0, currentValue - 1);
        headerCounter.textContent = newValue;
        
        if (headerCounter.classList.contains('badge') && newValue === 0) {
          headerCounter.style.display = 'none';
        }
      }
    }
    
    // Trigger eventi per aggiornamento UI
    window.dispatchEvent(new CustomEvent('wishlist:updated', { 
      detail: { 
        action: 'removed',
        variantId: variantId,
        remaining: document.querySelectorAll('teddy-wishlist-btn[data-variant].active').length - 1
      }
    }));
    
    if (window.MCEVENTS && window.MCEVENTS.WISHLIST_CHANGED) {
      window.dispatchEvent(new CustomEvent(window.MCEVENTS.WISHLIST_CHANGED));
    }
  }
};

window.removeFromWishlist = async function(variantId) {
  try {
    // Rimuovi il handle dal localStorage wishlist_with_size
    const removedBtn = document.querySelector(`teddy-wishlist-btn[data-variant="${variantId}"]`);
    const removedHandle = removedBtn ? removedBtn.dataset.handle : null;
    if (removedHandle) {
      let wishlistWithSize = JSON.parse(localStorage.getItem('wishlist_with_size') || '[]');
      wishlistWithSize = wishlistWithSize.filter(h => h !== removedHandle);
      localStorage.setItem('wishlist_with_size', JSON.stringify(wishlistWithSize));
    }

    const wishlistBtn = document.querySelector(`teddy-wishlist-btn[data-variant="${variantId}"]`);

    if (wishlistBtn) {
      window.wishlistInterceptorDisabled = true;
      
      wishlistBtn.click();
      
      await new Promise(resolve => setTimeout(resolve, 300));
      
      window.wishlistInterceptorDisabled = false;
      
      setTimeout(() => {
        const updatedBtn = document.querySelector(`teddy-wishlist-btn[data-variant="${variantId}"]`);
        
        if (updatedBtn && !updatedBtn.classList.contains('active')) {
          updateWishlistUI(variantId);
        } else if (!updatedBtn) {
        } else {
          setTimeout(() => {
            const stillActive = document.querySelector(`teddy-wishlist-btn[data-variant="${variantId}"].active`);
            if (!stillActive) {
              updateWishlistUI(variantId);
            }
          }, 1000);
        }
      }, 800);
      
    } else {
      if (window.teddyWishlistRemove) {
        await window.teddyWishlistRemove(variantId);
        await new Promise(resolve => setTimeout(resolve, 500));
        updateWishlistUI(variantId);
      }
    }
    
    window.dispatchEvent(new CustomEvent('wishlist:removed', { 
      detail: { variantId: variantId } 
    }));
    
    // Trigger anche l'evento MCEVENTS per aggiornare la wishlist page
    if (window.MCEVENTS && window.MCEVENTS.WISHLIST_CHANGED) {
      window.dispatchEvent(new CustomEvent(window.MCEVENTS.WISHLIST_CHANGED));
    }
    
  } catch (error) {
    window.location.reload();
  }
};

window.clearWishlist = async function() {
  try {
    // Svuota il localStorage wishlist_with_size
    localStorage.removeItem('wishlist_with_size');

    const wishlistItems = document.querySelectorAll('teddy-wishlist-btn.active');

    // Salva tutti i variant ID per nasconderli dopo il reload
    const variantIds = Array.from(wishlistItems).map(btn => btn.dataset.variant).filter(Boolean);
    if (variantIds.length > 0) {
      sessionStorage.setItem('removed_wishlist_variants', JSON.stringify(variantIds));
      sessionStorage.setItem('wishlist_cleared', 'true');
    }
    
    // Prova prima con la funzione force clear se disponibile
    if (window.forceClearWishlist) {
      const cleared = await window.forceClearWishlist();
      if (cleared) {
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
        return;
      }
    }
    
    // Altrimenti prova a salvare una wishlist vuota direttamente tramite l'API
    if (window.theme && window.theme.apis && window.theme.apis.wishlist && window.theme.apis.wishlist.save) {
      try {
        const response = await fetch(window.theme.apis.wishlist.save, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify([])
        });
        
        if (response.ok) {
          console.log('Wishlist cleared via API');
          // Aspetta un po' e poi ricarica
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
          return;
        }
      } catch (error) {
        console.error('Failed to clear wishlist via API:', error);
      }
    }
    
    if (wishlistItems.length > 0) {
      // NON disabilitare l'interceptor così il click viene gestito normalmente
      // window.wishlistInterceptorDisabled = true;
      
      // Rimuovi tutti gli articoli uno per uno con MOLTO più tempo tra ogni rimozione
      // per simulare il comportamento di un utente reale
      for (let i = 0; i < wishlistItems.length; i++) {
        const btn = wishlistItems[i];
        const variantId = btn.dataset.variant;
        
        if (!btn.classList.contains('active')) {
          // Se il pulsante non è più attivo, è già stato rimosso
          continue;
        }
        
        console.log(`Removing variant ${variantId} (${i + 1}/${wishlistItems.length})`);
        
        // Simula un click reale sul pulsante
        btn.click();
        
        // Aspetta che il pulsante non sia più active (indicando che la rimozione è completata)
        let attempts = 0;
        while (btn.classList.contains('active') && attempts < 20) {
          await new Promise(resolve => setTimeout(resolve, 500));
          attempts++;
        }
        
        // Aggiungi un delay extra tra rimozioni per non sovraccaricare l'API
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      
      // Aspetta ancora un po' per assicurarsi che tutto sia completato
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Verifica finale e aggiorna UI
      const remainingActive = document.querySelectorAll('teddy-wishlist-btn.active');
      
      if (remainingActive.length === 0) {
        console.log('All items removed successfully');
        updateUIAfterClear();
      } else {
        console.log(`${remainingActive.length} items still remain, retrying...`);
        // Riprova con gli elementi rimanenti
        for (const btn of remainingActive) {
          btn.click();
          await new Promise(resolve => setTimeout(resolve, 1500));
        }
        
        setTimeout(() => {
          updateUIAfterClear();
        }, 2000);
      }
      
      function updateUIAfterClear() {
          const cards = document.querySelectorAll('#wishlist-page .col');
          cards.forEach(card => {
            card.style.transition = 'opacity 0.3s ease-out';
            card.style.opacity = '0';
          });
          
          setTimeout(() => {
            const wishlistContainer = document.querySelector('#wishlist-page .row.row-cols-2, #wishlist-page .row.row-cols-md-4');
            if (wishlistContainer) {
              const emptyMessage = document.querySelector('[data-empty-wishlist-message]')?.textContent || 
                                  'La tua wishlist è vuota';
              wishlistContainer.innerHTML = `
                <div class="col-12 text-center py-5">
                  <p class="mb-0">${emptyMessage}</p>
                </div>
              `;
            }
            
            const countElement = document.querySelector('[data-wishlist-counter], .fw-bold.small');
            if (countElement) {
              const isItalian = countElement.textContent.includes('articol');
              countElement.textContent = isItalian ? '0 articoli presenti' : '0 items';
            }
            
            const clearSection = document.querySelector('teddy-wishlist-clear')?.closest('.border-top');
            if (clearSection) {
              clearSection.remove();
            }
            
            const headerCounter = document.querySelector('[data-wishlist-count], .wishlist-counter, .wishlist-count');
            if (headerCounter) {
              headerCounter.textContent = '0';
              if (headerCounter.classList.contains('badge')) {
                headerCounter.style.display = 'none';
              }
            }
            
            window.dispatchEvent(new CustomEvent('wishlist:cleared'));
            
            // Trigger anche l'evento MCEVENTS per aggiornare la wishlist page
            if (window.MCEVENTS && window.MCEVENTS.WISHLIST_CHANGED) {
              window.dispatchEvent(new CustomEvent(window.MCEVENTS.WISHLIST_CHANGED));
            }
          }, 300);
        }
      
    } else {
      const wishlistContainer = document.querySelector('#wishlist-page .row.row-cols-2, #wishlist-page .row.row-cols-md-4');
      if (wishlistContainer) {
        const emptyMessage = document.querySelector('[data-empty-wishlist-message]')?.textContent || 
                            'La tua wishlist è vuota';
        wishlistContainer.innerHTML = `
          <div class="col-12 text-center py-5">
            <p class="mb-0">${emptyMessage}</p>
          </div>
        `;
      }
      
      const countElement = document.querySelector('[data-wishlist-counter], .fw-bold.small');
      if (countElement) {
        const isItalian = countElement.textContent.includes('articol');
        countElement.textContent = isItalian ? '0 articoli presenti' : '0 items';
      }
    }
  } catch (error) {
    window.location.reload();
  }
};

document.addEventListener('DOMContentLoaded', function() {
  // Sync PDP: quando l'utente seleziona una taglia tramite variant-btn, salva in memoria
  // (non nel DOM perché la PDP ri-renderizza il bottone e perde gli attributi custom)
  window._wishlistSelectedVariant = null;
  window.addEventListener('variant:select', function(e) {
    if (!e.detail || !e.detail.url) return;
    try {
      const url = new URL(e.detail.url, window.location.origin);
      const variantId = url.searchParams.get('variant');
      if (!variantId) return;
      const btn = document.querySelector('.product-info-wishlist teddy-wishlist-btn');
      if (btn) {
        btn.dataset.variant = variantId;
        window._wishlistSelectedVariant = {
          variantId: variantId,
          handle: btn.getAttribute('data-handle')
        };
      }
    } catch(err) {
      console.warn('[Wishlist] variant:select error:', err);
    }
  });

  // Sync: quando l'utente seleziona una taglia (product card o Clerk), aggiorna il wishlist button
  document.addEventListener('click', function(e) {
    const label = e.target.closest('.variant-label');
    if (!label) return;

    // Cerca il container: product card (.product-card) o Clerk (.clerk-widget__item)
    const card = label.closest('.product-card') || label.closest('.clerk-widget__item');
    if (!card) return;

    const forAttr = label.getAttribute('for');
    if (!forAttr) return;
    const radio = document.getElementById(forAttr);
    if (!radio) return;

    const wishlistBtn = card.querySelector('teddy-wishlist-btn');
    if (wishlistBtn) {
      wishlistBtn.setAttribute('data-variant', radio.value);
      wishlistBtn.setAttribute('data-has-size', 'true');
    }
  });

  document.addEventListener('click', async function(e) {
    if (window.wishlistInterceptorDisabled) {
      return;
    }

    const wishlistBtn = e.target.closest('teddy-wishlist-btn');

    if (wishlistBtn) {
      const isInWishlist = wishlistBtn.classList.contains('active');

      if (isInWishlist) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const variantId = wishlistBtn.dataset.variant;

        window.wishlistConfirm('remove', () => {
          removeFromWishlist(variantId);
        });

        return false;
      } else {
        // Se una taglia è stata esplicitamente selezionata (PDP o product card), salva il handle nel localStorage
        const hasSize = wishlistBtn.getAttribute('data-has-size') === 'true';
        const pdpVariant = window._wishlistSelectedVariant;
        const handle = wishlistBtn.getAttribute('data-handle');

        if (hasSize || (pdpVariant && pdpVariant.handle === handle)) {
          if (handle) {
            let wishlistWithSize = JSON.parse(localStorage.getItem('wishlist_with_size') || '[]');
            if (!wishlistWithSize.includes(handle)) {
              wishlistWithSize.push(handle);
              localStorage.setItem('wishlist_with_size', JSON.stringify(wishlistWithSize));
            }
          }
          // Reset dopo l'uso
          if (pdpVariant && pdpVariant.handle === handle) {
            window._wishlistSelectedVariant = null;
          }
        }

        // Se l'articolo viene aggiunto alla wishlist dal carrello, rimuovilo dal carrello
        const isFromCart = wishlistBtn.dataset.fromCart === 'true';
        const cartKey = wishlistBtn.dataset.cartKey;
        
        if (isFromCart && cartKey) {
          // Salva il handle come "con taglia" (il carrello ha sempre una taglia)
          if (handle && !hasSize) {
            let wishlistWithSize = JSON.parse(localStorage.getItem('wishlist_with_size') || '[]');
            if (!wishlistWithSize.includes(handle)) {
              wishlistWithSize.push(handle);
              localStorage.setItem('wishlist_with_size', JSON.stringify(wishlistWithSize));
            }
          }

          // Aspetta che l'articolo sia aggiunto alla wishlist
          setTimeout(async () => {
            // Verifica che sia stato effettivamente aggiunto
            if (wishlistBtn.classList.contains('active')) {
              // Chiudi tutti i modal aperti prima di rimuovere dal carrello
              const allModals = document.querySelectorAll('.modal.show');
              allModals.forEach(modal => {
                const modalInstance = bootstrap.Modal.getInstance(modal);
                if (modalInstance) {
                  modalInstance.hide();
                }
              });
              
              // Pulisci eventuali backdrop rimasti
              setTimeout(() => {
                const backdrops = document.querySelectorAll('.modal-backdrop');
                backdrops.forEach(backdrop => backdrop.remove());
                document.body.classList.remove('modal-open');
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('padding-right');
              }, 150);
              
              // Rimuovi dal carrello
              if (window.McShopify && window.McShopify.updateCartLine) {
                window.McShopify.updateCartLine({
                  id: cartKey,
                  quantity: 0
                });
              }
            }
          }, 500);
        }
      }
    }
  }, true);
  
  document.addEventListener('click', function(e) {
    const clearBtn = e.target.closest('teddy-wishlist-clear');
    if (clearBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      window.wishlistConfirm('clear', () => {
        clearWishlist();
      });
      
      return false;
    }
  }, true);
})


// Gestione checkbox carrello
function initCartCheckboxes() {
  const privacyCheckbox = document.getElementById('privacyCheck');
  const newsletterCheckbox = document.getElementById('newsletterCheck');
  const profilazioneCheckbox = document.getElementById('profilazioneCheck');
  
  if (privacyCheckbox) {
    privacyCheckbox.addEventListener('change', function() {
      if (!this.checked) {
        this.value = '';
      } else {
        this.value = 'accepted';
      }
    });
  }

  if (newsletterCheckbox) {
    const newsletterHidden = document.getElementById('newsletterConsentHidden');
    
    newsletterCheckbox.addEventListener('change', function() {
      if (newsletterHidden) {
        newsletterHidden.value = this.checked ? 'true' : 'false';
      }
    });
  }
  
  if (profilazioneCheckbox) {
    const profilingHidden = document.getElementById('profilingConsentHidden');
    
    profilazioneCheckbox.addEventListener('change', function() {
      if (profilingHidden) {
        profilingHidden.value = this.checked ? 'true' : 'false';
      }
    });
  }
}

// Inizializza le checkbox del carrello quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartCheckboxes);
} else {
  initCartCheckboxes();
}

window.initCartCheckboxes = initCartCheckboxes;
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

document.addEventListener('DOMContentLoaded', function() {
  try{
    const pathname = window.location.pathname;
    const _url = window.location.href;
    const newUrl = _url.replace(pathname, pathname.slice(0, -1));
    
    if(pathname.endsWith('/') && pathname !== '/'){
      window.location.href = newUrl;
    }
  }catch(error){
    console.log(error);
  }

  try{
      const footerCountrySelectorToggle = document.getElementById('footer-country-selector-toggle');
      if(footerCountrySelectorToggle){
        footerCountrySelectorToggle.addEventListener('click', function() {
          setTimeout(() => {
          const countrySelector = document.getElementById('country-selector');
            if(countrySelector){
              countrySelector.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 300);
        });
      }
  }catch(error){
    console.log(error);
  }
});